import { useT4EObuDevices } from 'entities/cars';
import { useNavigationAutoObuPairs } from 'entities/navigation';

export const useGetListUnactiveDevices = () => {
  const t4EboxDevices = useT4EObuDevices();
  const obuDevices = useNavigationAutoObuPairs();

  if (!obuDevices) {
    return t4EboxDevices;
  }

  return t4EboxDevices.filter(({ clientObuId }) => {
    return !obuDevices.find(({ obuNumber }) => obuNumber === clientObuId);
  });
};
